import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { CostCenters } from "../cost-centers/cost-centers.entity";
import { EmployeeDetails } from "../employee-details/employee-details.entity";
import { ProjectMapping } from '../project-mapping/project-mapping.entity';
import { States } from "../states/states.entity";
@Entity('projects')
export class Projects {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    projectId: number;
    @Column("char", {
        nullable: false,
        length: 25,
        name: "project_code"
    })
    @Index({ unique: true })
    projectCode: string;
    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "project_name"
    })
    projectName: string;
    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "project_description"
    })
    projectDescription: string;
    @Column("int", {
        name: "cost_center_id"
    })
    costCenterId: number;
    @Column("int", {
        name: "state_id"
    })
    stateId: number;
    @Column("varchar", {
        nullable: true,
        name: "ot_type"
    })
    otType: string;
    @Column({
        nullable: true,
        name: "start_date",
        type: "date"
    })
    startDate: Date;
    @Column("varchar", {
        length: 60,
        nullable: true,
        name: "location"
    })
    location: string;
    @Column("varchar", {
        length: 60,
        nullable: true,
        name: "latitude"
    })
    latitude: string;
    @Column("varchar", {
        length: 60,
        nullable: true,
        name: "longitude"
    })
    longitude: string;
    @Column("boolean", {
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"status"
        })
      status:boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;
    @Column("int", {
        nullable: false,
        name: "created_user"
    })
    createdUser: number | null;
    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("int", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: number | null;
    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @OneToMany(type=>Projects, projects=>projects.projectId,{cascade: true})
    projectsInfo:Projects[];
    @OneToOne(() => EmployeeDetails, employeeDetails => employeeDetails.projectId) 
  // specify inverse side as a second parameter
    employeeDetails: EmployeeDetails;
    // @OneToMany(type=>ProjectMapping, projectMapping=>projectMapping.projectId,{cascade: true})
    // projectMappingInfo:ProjectMapping[];

    @OneToMany(type => ProjectMapping, projectMapping => projectMapping.projectsInfo)
    projectMapping: ProjectMapping[];
    @OneToOne(() => CostCenters, costCenters => costCenters.costCenterId) 
    // specify inverse side as a second parameter
    costCenters: CostCenters;
    @OneToOne(() => States, states => states.stateId) 
    // specify inverse side as a second parameter
    states: States;
}
